import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import './ModalCreateEventForm.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faComment } from '@fortawesome/free-solid-svg-icons';
import Form from 'react-bootstrap/Form';
import fetchData from '../../../function/fetchData';


function ModalCreateEventForm({showModalCreateEventFrom, setShowModalCreateEventFrom, selectedOne, dataFromServer, fetchDataFromServer, token, server}) {
    const [typeOff , setTypeoff] = useState('schedule')


    // SCHEDULE
    const Schedule = ({selectedOne, dataFromServer, server, token}) => {
        const [selectedTypeOfSchedule, setSelectedTypeOfSchedule] = useState(null)
        const [selectedDriver, setSelectedDriver] = useState(null)
        const dayOfWeek = selectedOne?.dayOfWeek ?? null
        const drivers = dataFromServer?.drivers ?? []

        const scheduleList = dataFromServer?.schedule_offer ?? []

        // Rozvrh na daný den
        const schedule = scheduleList.filter( (one)=> {
            return parseInt(one.day_of_week) === parseInt(dayOfWeek)
        })

        // Vytáhne z rozvrhu jen jednu směnu
        const getSchedule = (id) => {
            const result = scheduleList.filter(one => {
                return parseInt(one.id) === parseInt(id)
            })
            console.log(result)
            return result ? result[0] : null
        }


        const formatTime = (time) => {
            if(time){
                const result = time.split(':')
                return result[0] + ':' + result[1]
            }
        };

                
        const handleTake = () => {
            if(selectedTypeOfSchedule && selectedDriver) {
                const selectedSchedule = getSchedule(parseInt(selectedTypeOfSchedule))
   
                const whatToSend = {
                    action: 'SAVE' ,
                    driverToken: token, 
                    start: selectedOne.date.format('YYYY-MM-DD') + " " + selectedSchedule.start, 
                    end: selectedOne.date.format('YYYY-MM-DD') + " " + selectedSchedule.end, 
                    idOfDriver: parseInt(parseInt(selectedDriver)), // id řidiče
                    id: parseInt(selectedTypeOfSchedule)
                }
    
    
                fetchData(server + 'api2/scheduleController.php' , whatToSend)
                .then( (res) => {
                    console.log(res)
                    if(res.status === "OK"){
                        fetchDataFromServer()
                        setShowModalCreateEventFrom(false)

                    } else if(res.status === "NOT_YET") {
                    alert(res.message)
                    } else {
                    alert('Nastala chyba, nebo je již zakázka obsazená')
    
                    }
                })
            } else {
                alert('Nezvolili jste šichtu, nebo řidiče')
            }
        }
        
        return(
            <>
                Vyberte druh šichty
                <Form.Select aria-label="Default select example" onChange={(e)=>setSelectedTypeOfSchedule(e.target.value)}>
                    <option>Vyberte druh šichty</option>
                    {
                        schedule.map(one => {
                            return <option key={one.id} value={one.id}>{one.type} | {formatTime(one.start)} - {formatTime(one.end)}</option>
                        })
                    }
                </Form.Select>

                <Form.Select aria-label="Default select example"  style={{marginTop: 10}}  onChange={(e)=>setSelectedDriver(e.target.value)}>
                    <option>Vyberte řidiče</option>
                    {
                        drivers.map( oneDriver => {
                            return <option key={oneDriver.id} value={oneDriver.id}>{oneDriver.nick}</option>
                        })
                    }
                </Form.Select>

 
                <Button variant="success" className='btn' style={{marginTop: 20}} onClick={handleTake}>
                        <FontAwesomeIcon icon={faCalendar} />
                        Uložit
                </Button>
            </>

        )
    }

    // CALENDAR
    const Calendar = ({selectedOne, dataFromServer}) => {
        const [note, setNote] = useState('')
        const dayOfWeek = selectedOne?.dayOfWeek ?? null

        // Pošle data
        const handleSaveOrEdit = () => {
            if(note.length > 3){
    
                const whatToSend = {
                    action:  'CREATE_EVENT' ,
                    id: null,
                    text: note,
                    driverToken: token,
                    date: selectedOne.date.format('YYYY-MM-DD') 
                }

                fetchData(server + 'api2/calendarController.php' , whatToSend)
                .then( (res) => {
                    if(res.status === "OK"){
                        fetchDataFromServer()
                        setShowModalCreateEventFrom(false)
                    } else {
                        alert('Nastala chyba, zkuste to prosím později.')
                    
                    }
                })
            } else {
                alert('Zadejte text')
            }
        }

        return(
            <>
                <Form.Label htmlFor="inputPassword5">Poznámka</Form.Label>
                <Form.Control
                    type="text"
                    value={note}
                    onChange={(event)=> setNote(event.target.value)}
                    />
                    <Form.Text>
                    Zadejte poznámku pro událost.
                </Form.Text>

                <Button variant="success" className='btn'  style={{marginTop: 20}} onClick={handleSaveOrEdit}>
                        <FontAwesomeIcon icon={faCalendar} />
                        Uložit
                </Button>
            </>

        )
    }

    return (
        <>
        <Modal
            size="lg"
            show={showModalCreateEventFrom}
            onHide={() => setShowModalCreateEventFrom(false)}
            aria-labelledby="example-modal-sizes-title-lg"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                    Vytvořit událost pro den: {selectedOne && selectedOne.date.format('dddd, DD MMMM')}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className='btnContainer'>
                    <Button variant="light" className='btn' onClick={()=>setTypeoff('schedule')}>
                        <FontAwesomeIcon icon={faCalendar} />
                        Vložit šichtu
                    </Button>
                    <Button variant="light" className='btn'  onClick={()=>setTypeoff('calendar')}>
                        <FontAwesomeIcon icon={faComment} />
                        Vložit Poznámku
                    </Button>
                </div>

                <Alert variant="success" style={{marginTop: 10}}>
                    <Alert.Heading>{ typeOff === 'schedule' ? 'Naplánujte šichtu sobě či ostatním řidičům' : 'Uložte poznámku do kalendáře' }</Alert.Heading>
                    <p>
         
                    </p>
                    <hr />
                    <p className="mb-0">
                            { typeOff === 'calendar' && <Calendar selectedOne={selectedOne} dataFromServer={dataFromServer} token={token} server={server}/> }
                            { typeOff === 'schedule' && <Schedule selectedOne={selectedOne} dataFromServer={dataFromServer} token={token} server={server}/> }
                    </p>
                </Alert>
            </Modal.Body>
        </Modal>
        </>
    );
}

export default ModalCreateEventForm;